var entryManager = require('./entry-manager.js');
const crypto = require('crypto');

function createSHA256Hash(inputString) {
	const hash = crypto.createHash('sha256');
	hash.update(inputString);
	return hash.digest('hex');
}

var oldSceneSetup =
{
	scenes:
		[
			{
				sceneType: "video",
				sceneId: "scene-1",
				videoId: "video-1",
				onVideoEndScene: "scene-2"
			},
			{
				sceneType: "video",
				sceneId: "scene-2",
				videoId: "video-2",
				onVideoEndScene: "scene-3"
			},
			{
				sceneType: "choise",
				sceneId: "scene-3",
				videoId: "",
				onVideoEndScene: "",
				choises:
				{
					choiseAId: "choise-a",
					choiseBId: "choise-b",

					question: "Vind je dat hij een praatje moet maken met zijn (nieuwe) buurtbewoners?",
					a: { text: "Nee, joh.", nextSceneId: "" },
					b: { text: "Ja, natuurlijk!", nextSceneId: "" }
				}
			},
			{
				sceneType: "video",
				sceneId: "scene-4",
				videoId: "video-3",
				onVideoEndScene: "scene-6"
			},
			{
				sceneType: "video",
				sceneId: "scene-5",
				videoId: "video-4",
				onVideoEndScene: "scene-6"
			}
			,
			{
				sceneType: "video",
				sceneId: "scene-6",
				videoId: "video-5",
				onVideoEndScene: "index_end.html"
			}
		]
}

var newSceneSetup =
{
	scenes:
		[
			{
				sceneType: "video",
				sceneId: "scene-1",
				videoId: "video-1",
				onVideoEndScene: "scene-2"
			},
			{
				sceneType: "choise",
				sceneId: "scene-2",
				videoId: "",
				onVideoEndScene: "",
				choises:
				{
					choiseAId: "choise-a",
					choiseBId: "choise-b",
					choiseCId: "choise-c",

					question: "",
					a: { text: "", nextSceneId: "" },
					b: { text: "", nextSceneId: "" },
					c: { text: "", nextSceneId: "" }
				}
			},
			{
				sceneType: "video",
				sceneId: "scene-3",
				videoId: "video-2",
				onVideoEndScene: "scene-6"
			},
			{
				sceneType: "video",
				sceneId: "scene-4",
				videoId: "video-3",
				onVideoEndScene: "scene-6"
			},
			{
				sceneType: "video",
				sceneId: "scene-5",
				videoId: "video-4",
				onVideoEndScene: "scene-6"
			},
			{
				sceneType: "video",
				sceneId: "scene-6",
				videoId: "video-5",
				onVideoEndScene: "index_end_new.html"
			}
		]
}

var newSceneSetupEnglish =
{
	scenes:
		[
			{
				sceneType: "video",
				sceneId: "scene-1",
				videoId: "video-1",
				onVideoEndScene: "scene-2"
			},
			{
				sceneType: "choise",
				sceneId: "scene-2",
				videoId: "",
				onVideoEndScene: "",
				choises:
				{
					choiseAId: "choise-a",
					choiseBId: "choise-b",
					choiseCId: "choise-c",

					question: "",
					a: { text: "", nextSceneId: "" },
					b: { text: "", nextSceneId: "" },
					c: { text: "", nextSceneId: "" }
				}
			},
			{
				sceneType: "video",
				sceneId: "scene-3",
				videoId: "video-2",
				onVideoEndScene: "scene-6"
			},
			{
				sceneType: "video",
				sceneId: "scene-4",
				videoId: "video-3",
				onVideoEndScene: "scene-6"
			},
			{
				sceneType: "video",
				sceneId: "scene-5",
				videoId: "video-4",
				onVideoEndScene: "scene-6"
			},
			{
				sceneType: "video",
				sceneId: "scene-6",
				videoId: "video-5",
				onVideoEndScene: "index_end_new_en.html"
			}
		]
}

const singleVideoSetup =
{
	scenes:
		[
			{
				sceneType: "video",
				sceneId: "scene-1",
				videoId: "video-1",
				onVideoEndScene: "index_end_new.html"
			}
		]
}

var sixVideoSetup =
{
	scenes:
		[
			{
				sceneType: "video",
				sceneId: "scene-1",
				videoId: "video-1",
				onVideoEndScene: "scene-2"
			},
			{
				sceneType: "video",
				sceneId: "scene-2",
				videoId: "video-2",
				onVideoEndScene: "scene-3"
			},
			{
				sceneType: "choise",
				sceneId: "scene-3",
				videoId: "",
				onVideoEndScene: "",
				choises:
				{
					choiseAId: "choise-a",
					choiseBId: "choise-b",
					choiseCId: "choise-c",

					question: "",
					a: { text: "", nextSceneId: "" },
					b: { text: "", nextSceneId: "" },
					c: { text: "", nextSceneId: "" }
				}
			},
			{
				sceneType: "video",
				sceneId: "scene-4",
				videoId: "video-3",
				onVideoEndScene: "scene-7"
			},
			{
				sceneType: "video",
				sceneId: "scene-5",
				videoId: "video-4",
				onVideoEndScene: "scene-7"
			},
			{
				sceneType: "video",
				sceneId: "scene-6",
				videoId: "video-5",
				onVideoEndScene: "scene-7"
			},
			{
				sceneType: "video",
				sceneId: "scene-7",
				videoId: "video-6",
				onVideoEndScene: "index_end_new.html"
			}
		]
}

var global_critical_mass_variables =
{
	currentSCeneSetup: undefined,
	data: undefined,
	startedScene: false
};


AFRAME.registerComponent('scene-controller', {
	schema: {
		on: { type: 'string' },
		target: { type: 'selector' },
		src: { type: 'string' },
		dur: { type: 'number', default: 300 },
		currentSceneId: { type: 'string' },
		currentSceneIndex: { type: 'number' },
		sceneSetupToUse: { type: 'number', default: 0 }
	},

	init: function () {

		console.log("Init scene controller");
		const params = new URLSearchParams(window.location.search)
		if (!params.has('password')) {
			returnToHome();
			return null;
		}
		const password = params.get('password');
		entryManager.getJSON(function (err, data) {
			if (err != null) {
				console.error(err);
				returnToHome();
				return false;
			}
			else {
				var path = window.location.pathname;
				var page = path.split("/").pop();

				// Mapping should be in the same order as the whats coming from the json.
				const mapping = {
					entries: [
						'index_chris.html',
						'index_dayo.html',
						'index_kaltoum.html',
						'index_roy.html',
						'index_sollicitant.html',
						'index_sollicitant_en.html',
						'index_kleedkamer.html',
						'index_kleedkamer_en.html',
						'index_lunchpauze.html',
						'index_lunchpauze_en.html',
						'index_huisbezichtiging.html',
						'index_huisbezichtiging_en.html',
						'index_kantoor.html',
						'index_monteurs.html',
						'index_selectietraining.html',
						'index_projectplanetnl.html',
						'index_projectplaneten.html',
						'index_mentaalfit.html',
						'index_obstipatie.html',
						'index_badmeester.html',
						'index_damesgaanvoor.html',
						'index_brandstof.html',
						'index_stage.html',
						'index_voetbal.html',

					]
				};
				var gotCorrectPassword = false;
				for (var i = 0; i < data.pairs.length; i++) {
					if (mapping.entries.length > i && page == mapping.entries[i] && data.pairs[i].paswordValue == createSHA256Hash(password)) {
						gotCorrectPassword = true;
						break;
					}
				}
				if (!gotCorrectPassword) {
					returnToHome();
					return false;
				}
			}
		});

		if (this.data.sceneSetupToUse === 0) {
			global_critical_mass_variables.currentSCeneSetup = oldSceneSetup;
		} else if (this.data.sceneSetupToUse === 1) {
			global_critical_mass_variables.currentSCeneSetup = newSceneSetup;
		} else if (this.data.sceneSetupToUse === 2) {
			global_critical_mass_variables.currentSCeneSetup = sixVideoSetup;
		} else if (this.data.sceneSetupToUse === 3) {
			global_critical_mass_variables.currentSCeneSetup = newSceneSetupEnglish;
		} else if (this.data.sceneSetupToUse === 4) {
			global_critical_mass_variables.currentSCeneSetup = singleVideoSetup;
		}

		var htmlScene = document.querySelector("a-scene");
		var data = this.data

		data.currentSceneId = global_critical_mass_variables.currentSCeneSetup.scenes[0].sceneId;
		data.currentSceneIndex = 0;

		global_critical_mass_variables.data = data;

		document.getElementById('frontClickReciever').addEventListener('click', OnFirstStart);

		function OnFirstStart(e) {
			console.log(e)
			if (!e.isTrusted) {
				return;
			}
			console.log('trusted click for OnFirstStart');
			if (htmlScene.hasLoaded) {
				RunIntro(global_critical_mass_variables.currentSCeneSetup);
			} else {
				if (global_critical_mass_variables.startedScene == false) {
					document.querySelector("a-scene").addEventListener("loaded", RunIntro);
					global_critical_mass_variables.startedScene = true;
				}
			}

		}

		function RunIntro() {
			document.getElementById('frontClickReciever').removeEventListener('click', OnFirstStart);
			var element = document.getElementById('frontClickReciever');
			element.classList.add("a-hidden");

			var playbutton = document.getElementById('playButton');
			if (playbutton) {
				playbutton.parentNode.removeChild(playbutton);
			}

			global_critical_mass_variables.currentSCeneSetup.scenes.forEach(scene => SetUpScene(scene));
			SetSceneActive(data.currentSceneIndex);
			document.querySelector("a-scene").removeEventListener('loaded', RunIntro);
			document.querySelector("a-scene").addEventListener('click', ResetVideoForIOS);
		}

		function SetUpScene(scene) {
			document.addEventListener("answerGiven", ButtonSelected);
			switch (scene.sceneType) {
				case "video":
					console.log(scene.videoId);
					var video = document.getElementById(scene.videoId);
					video.playsInline = true;
					video.addEventListener("ended", OnVideoEnded);
					break;

				case "choise":
					break;

			}
		}

		function ButtonSelected(e) {
			if (data.currentSceneId == e.detail.sceneid) {
				var answer = e.detail.answer;
				var choiseDependendSceneToGoTo = answer;
				SetSceneActive(GetIndexOfSceneToGo(choiseDependendSceneToGoTo));
			}
		}


		function SetSceneActive(index) {
			if (index >= global_critical_mass_variables.currentSCeneSetup.scenes.length) {
				window.location.href = global_critical_mass_variables.currentSCeneSetup.scenes[data.currentSceneIndex].onVideoEndScene;
			} else {
				data.currentSceneIndex = index;
				data.currentSceneId = global_critical_mass_variables.currentSCeneSetup.scenes[index].sceneId;
				global_critical_mass_variables.currentSCeneSetup.scenes.forEach(scene => Activate(scene));
			}

		}

		function Activate(scene) {
			var isTargetScene = (data.currentSceneId == scene.sceneId);
			document.getElementById(scene.sceneId).setAttribute('visible', isTargetScene);

			switch (scene.sceneType) {
				case "video":
					var video = document.getElementById(scene.videoId);
					if (isTargetScene) {
						video.play();
						video.pause();
						video.play();
					} else {
						video.pause();
					}
					break;

				case "choise":
					// code block for setting up choise scene
					break;

			}
		}

		function returnToHome() {
			window.location.href = "index.html";
		}

		function ResetVideoForIOS(e) {
			if (!e.isTrusted) {
				return;
			}

			var videoId = global_critical_mass_variables.currentSCeneSetup.scenes[data.currentSceneIndex].videoId;
			if (videoId != "") {
				var vid = document.getElementById(videoId);
				if (vid != undefined) {
					if (vid.paused) {
						vid.play();
					}
				}
			}
		}

		function OnVideoEnded() {
			SetSceneActive(GetIndexOfSceneToGo(global_critical_mass_variables.currentSCeneSetup.scenes[data.currentSceneIndex].onVideoEndScene));
		}

		function GetIndexOfSceneToGo(sceneToGoTo) {
			var newIndex = global_critical_mass_variables.currentSCeneSetup.scenes.length;

			for (var i = 0; i < global_critical_mass_variables.currentSCeneSetup.scenes.length; i++) {
				if (global_critical_mass_variables.currentSCeneSetup.scenes[i].sceneId == sceneToGoTo) {
					newIndex = i;
					break;
				}
			}
			return newIndex;
		}
	},

});